import { render } from "./VirtualMailboxesPasswordManagerDialog.vue?vue&type=template&id=30048a55&scoped=true"
import script from "./VirtualMailboxesPasswordManagerDialog.vue?vue&type=script&lang=ts"
export * from "./VirtualMailboxesPasswordManagerDialog.vue?vue&type=script&lang=ts"

import "./VirtualMailboxesPasswordManagerDialog.vue?vue&type=style&index=0&id=30048a55&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30048a55"

export default script